import '../App.css'

function Partijen() {
  const parties = [
    {
      name: 'PvdAGL',
      description: 'PvdA / GroenLinks',
    },
    {
      name: 'BBB',
      description: 'Boer Burger Beweging',
    },
    {
      name: 'CDA',
      description: 'CDA',
    },
    {
      name: 'D66',
      description: 'D66',
    },
    {
      name: 'FvD',
      description: 'Forum',
    },
    {
      name: 'Volt',
      description: 'Volt',
    },
    {
      name: 'PVV',
      description: 'Partij voor de Vrijheid',
    },
    {
      name: 'NSC',
      description: 'Nieuw Sociaal Contract',
    },
    {
      name: 'VVD',
      description: 'VVD',
    },
    {
      name: 'PvdD',
      description: 'Partij voor de Dieren',
    }
  ]

  return (
    <main className='colspan12' id='party-list'>
      <h1>Dit zijn alle partijen van Reza Meems</h1>
      {
        parties.map(party => {
          return (
            <div key={party.name} className='partij-display'>
              <img src={`ali posters/${party.name}.webp`}></img>
              <div>
                <h2>{party.name}</h2>
                <p>{party.description}</p>
              </div>
            </div>
          )
        })
      }
    </main>
  )
}

export default Partijen
